__webpack_require__.p = "/energy/water/paper/Remediation_Potential/";